import {
  Menu as MenuIcon
} from "@mui/icons-material";
import {
  Toolbar
} from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { logout } from "../../redux/actions/auth";
import { StyledHeader } from "../styled/Layout";
import UserActionsContainer from "./UserActionsContainer";



const HeaderAppBar = ({ open, handleDrawerToggle }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [cerrarSesion, setCerrarSesion] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  const handleLogout = () => {
    dispatch(logout());
    location.pathname = "/";
  };
  const handleOpenDialog = () => {
    setCerrarSesion(true);
  };
  const handleCloseDialog = () => {
    setCerrarSesion(false);
  };

  const handleOpenMenu = (event) => {
    setOpenMenu(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };
  return (
    <>
      <StyledHeader.AppBar open={open}
        position="fixed"
      >
        <Toolbar>
          <StyledHeader.MenuButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            edge="start"
            open={open}
          >
            <MenuIcon />
          </StyledHeader.MenuButton>
          <StyledHeader.Logout>
            <UserActionsContainer />
          </StyledHeader.Logout>
        </Toolbar>
      </StyledHeader.AppBar>
    </>
  );
};

export default HeaderAppBar;
